import { onMounted, reactive, toRefs, watch, unref, Vue2 } from 'vue-demi'
import { useTable } from '@/utils/commonUse'
import service from '@/service/courseAndGroup/index'

export function useGetParams() {
  const state = reactive({
    subjectList: [],
    gradeList: [],
    periodList: [],
    classStyleList: []
  })
  /**
   * @description 获取列表参数
   */
  const getParams = () => {
    service.getParams().then(res => {
      const { gradeList, subjectList, periodList, classStyleList } = res
      state.gradeList = gradeList
      state.subjectList = subjectList
      state.periodList = periodList
      state.classStyleList = classStyleList
    })
  }
  onMounted(() => {
    getParams()
  })
  return {
    ...toRefs(state)
  }
}

/**
 * @description 获取课程列表
 * @param {筛选课程列表所需参数} param
 * @returns
 */
export function useGetCourseList (param, selectedCourseId, refs) {
  const state = reactive({
    // 课程分页数据
    coursePagination: {
      current: 1,
      pageSize: 20,
      totalPage: 0
    },
    courseTableLoading: false,
    // 课程列表数据
    courseList: []
  })
  const { scroll, getScroll } = useTable()
  /**
   * @description 获取课程列表
   */
  const getCourseList = () => {
    console.log('11')
    state.courseTableLoading = true
    const { current: pageNum, pageSize } = state.coursePagination
    const httpParam = {
      pageNum,
      pageSize,
      ...param
    }
    if (httpParam.experience) {
      httpParam.experience = 1
    } else {
      delete httpParam.experience
    }
    service.getCourseList(httpParam).then(res => {
      const { list, itemTotal } = res
      state.courseList = list || []
      state.coursePagination.totalPage = itemTotal
      const tableDom = refs.table.$el
      Vue2.nextTick(() => getScroll(tableDom))
      if (state.courseList.length < 1) return
      // 如果没有选中项，设置第一个为选中项
      if (unref(selectedCourseId) < 0) {
        const [firstItem] = state.courseList
        selectedCourseId.value = firstItem.classTypeId
      }
    }).catch(res => {
    }).finally(() => { state.courseTableLoading = false })
  }

  onMounted(() => {
    getCourseList()
  })

  watch([() => state.coursePagination.current], () => {
    getCourseList()
  })

  return {
    ...toRefs(state),
    scroll,
    getCourseList
  }
}

/**
 * @description 获取小组列表
 * @param {课程id} param
 */
export function useGetGroupList(courseId) {
  // 小组分页数据
  const state = reactive({
    groupPagination: {
      current: 1,
      pageSize: 50,
      totalPage: 0
    },
    // 小组数据
    groupList: [],
    groupListLoading: false
  })
  /**
   * @description 获取小组列表
   */
  const getGroupList = () => {
    const { current: pageNum, pageSize } = state.groupPagination
    const param = {
      classTypeId: unref(courseId),
      hideStatus: 0, // 0未隐藏，1已隐藏
      pageNum,
      pageSize
    }
    state.groupListLoading = true
    service.getGroupList(param).then(res => {
      const { list, itemTotal } = res
      state.groupList = list
      state.groupPagination.totalPage = itemTotal
    }).catch().finally(() => {
      state.groupListLoading = false
    })
  }
  // 监听课程id变化
  watch(() => courseId.value, val => {
    if (!val || val === -1) return
    state.groupPagination.current = 1
    getGroupList()
  })
  // 监听页数变化
  watch(() => state.groupPagination.current, val => {
    getGroupList()
  })
  return {
    ...toRefs(state),
    getGroupList
  }
}